<template>
    <div class="icdcodes-component">
        <div class="card">
            <div class="card-body">
                <div v-if="isEdit" class="mb-1">
                    <!-- <p class="mb-1"><b>Assign ICD 10 Codes</b></p> -->
                    <searchable-dropdown @search="searchIcdCodes" :options="icdCodeList" :isLoading="isLoadingResult" @selected="selectCode" :maxHeight="250" :inputClass="inputClass"></searchable-dropdown>
                    <hr class="mt-2 mb-0">
                </div>
                <div>
                    <p class="mb-1"><b>Assigned ICD 10 Codes</b></p>
                    <div v-if="!value || value.length === 0"><span class="font-italic">No ICD 10 Codes added yet.</span></div>
                    <div v-else class="icdcode-wrapper">
                        <div v-for="(code, index) in value" :key="index" class="icdcode-item">
                            <div class="text-nowrap">
                                {{code}}
                            </div>
                            <div v-if="isEdit" class="code-delete">
                                <a href="javascript: void(0);" class="delete-button" @click="removeCode(index)"><i class="fas fa-trash-alt"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import debounce from 'debounce';
import searchableDropdown from '@/components/searchable-dropdown';
export default {
    'name': 'ICDCodeComponent',
    'components': {
        searchableDropdown
    },
    'props': {
        'value': {
            'type': Array
        },
        'isEdit': {
            'value': Boolean,
            'default': true
        },
        'inputClass': {
            'value': String,
            'default': ''
        }
    },
    data () {
        return {
            'icdCodeList': [],
            'isLoadingResult': false,
            'searchIcdCodes': null
        };
    },
    created () {
        let vm = this;
        this.searchIcdCodes = debounce((text) => {
            vm.icdCodeList = [];

            if (text) {
                vm.isLoadingResult = true;
                // call ajax here
                vm.axios.get('IcdCode/GetIcdCodeList',
                    { 'params': {
                        'f': text
                    } }).then(({ data }) => {
                    vm.isLoadingResult = false;
                    vm.icdCodeList = data.data.map((code) => ({
                        'value': code.c,
                        'text': `${code.c} - ${code.d}`
                    }));
                });
            }
        }, 300);
    },
    'methods': {
        selectCode (code) {
            this.value.push(code);
        },
        removeCode (index) {
            if (this.value) {
                this.value.splice(index, 1);
            }
        }
    }
};
</script>

<style>
   .icdcode-wrapper {
        display: flex;
        flex-wrap: wrap;
        margin-right: -5px;
        margin-bottom: -5px;
    }

    .icdcode-wrapper .icdcode-item {
        margin-right: 5px;
        margin-bottom: 5px;
        color: #009344;
        border: 1px solid #009344;
        padding: 2px;
        border-radius: .25rem;
        display: flex;
        align-items: center;
    }

    .icdcode-wrapper .icdcode-item .code-delete{
        margin-left: 10px;
    }

    .icdcode-wrapper .icdcode-item .code-delete a.delete-button{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 25px;
        height: 25px;
        color: #dc3545;
        text-decoration: none;
    }

    /* New Design CSS, REMOVE IF REVERT TO OLD DESIGN */
    .icdcodes-component .card {
        border: 0;
    }

    .icdcodes-component .card-body {
        padding: 0;
        font-size: 14px;
    }
    .icdcodes-component input {
        font-size: 14px;
    }
</style>
